import { jsx as _jsx } from "react/jsx-runtime";
import { BrowserRouter } from 'react-router-dom';
import App from '../app';
import { getJSONFromScriptTag } from '@phishtool/ui';
import Providers from '~providers/index';
const Router = () => {
    const state = getJSONFromScriptTag('preloaded-state');
    return (_jsx(BrowserRouter, { children: _jsx(Providers, Object.assign({}, state, { children: _jsx(App, {}) })) }));
};
export default Router;
